import { useState } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { Button } from '@/components/ui/Button'
import { CsSection } from '@/components/Cs/CsSection'
import { csFieldClass } from '@/components/Cs/csFormStyles'
import { CS_TRATATIVA_TIPOS, type CsAccountDetail } from '@/services/csService'

type Props = {
  account: CsAccountDetail
  onCreate: (payload: {
    tipo: string
    descricao: string
    responsavelUserId: string
    resultado?: string
  }) => Promise<void>
  onAddInteraction: (payload: { tipo: string; descricao?: string }) => Promise<void>
}

export function CsAccountTratativas({ account, onCreate, onAddInteraction }: Props) {
  const user = useAuthStore((s) => s.user)
  const [tipo, setTipo] = useState('RECLAMACAO')
  const [descricao, setDescricao] = useState('')
  const [intTipo, setIntTipo] = useState('REUNIAO')
  const [intDesc, setIntDesc] = useState('')

  return (
    <CsSection title='Tratativas e interações'>
      <h4 className='mb-2 text-xs font-semibold uppercase tracking-wide text-[var(--text-muted)]'>Nova tratativa</h4>
      <div className='mb-4 flex flex-wrap gap-2'>
        <select className={csFieldClass} style={{ width: 'auto' }} value={tipo} onChange={(e) => setTipo(e.target.value)}>
          {CS_TRATATIVA_TIPOS.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
        <input
          className={`${csFieldClass} min-w-[200px] flex-1`}
          placeholder='Descrição da tratativa…'
          value={descricao}
          onChange={(e) => setDescricao(e.target.value)}
        />
        <Button
          size='sm'
          variant='primary'
          onClick={() => {
            if (!descricao.trim() || !user?.id) return
            void onCreate({
              tipo,
              descricao: descricao.trim(),
              responsavelUserId: user.id,
            }).then(() => setDescricao(''))
          }}
        >
          Registrar tratativa
        </Button>
      </div>

      <ul className='mb-6 space-y-2'>
        {account.tratativas.map((t) => (
          <li key={t.id} className='rounded-lg border border-[var(--glass-border)] px-3 py-2 text-sm'>
            <div className='flex justify-between gap-2'>
              <span className='font-semibold'>
                {t.tipo} · {t.status}
              </span>
              <span className='text-xs text-[var(--text-muted)]'>{new Date(t.data).toLocaleString('pt-BR')}</span>
            </div>
            <p className='mt-1 text-[var(--text-muted)]'>{t.descricao}</p>
            <p className='mt-1 text-xs text-[var(--text-muted)]'>Resp.: {t.responsavel.name}</p>
          </li>
        ))}
        {account.tratativas.length === 0 && (
          <p className='text-sm text-[var(--text-muted)]'>Nenhuma tratativa ainda.</p>
        )}
      </ul>

      <h4 className='mb-2 text-xs font-semibold uppercase tracking-wide text-[var(--text-muted)]'>
        Interação rápida
      </h4>
      <div className='mb-3 flex flex-wrap gap-2'>
        <select className={csFieldClass} style={{ width: 'auto' }} value={intTipo} onChange={(e) => setIntTipo(e.target.value)}>
          <option value='REUNIAO'>Reunião</option>
          <option value='WHATSAPP'>WhatsApp</option>
          <option value='EMAIL'>E-mail</option>
          <option value='CHECKIN'>Check-in</option>
        </select>
        <input
          className={`${csFieldClass} min-w-[200px] flex-1`}
          value={intDesc}
          onChange={(e) => setIntDesc(e.target.value)}
          placeholder='Resumo…'
        />
        <Button
          size='sm'
          variant='secondary'
          onClick={() => {
            if (!intDesc.trim()) return
            void onAddInteraction({ tipo: intTipo, descricao: intDesc.trim() }).then(() => setIntDesc(''))
          }}
        >
          Registrar
        </Button>
      </div>
      <ul className='space-y-2'>
        {account.interacoes.slice(0, 10).map((i) => (
          <li key={i.id} className='rounded-lg border border-[var(--glass-border)] px-3 py-2 text-sm'>
            <div className='flex justify-between gap-2'>
              <span className='font-semibold'>{i.tipo}</span>
              <span className='text-xs text-[var(--text-muted)]'>{new Date(i.data).toLocaleString('pt-BR')}</span>
            </div>
            {i.descricao && <p className='mt-1 text-[var(--text-muted)]'>{i.descricao}</p>}
          </li>
        ))}
      </ul>
    </CsSection>
  )
}
